// extracted by mini-css-extract-plugin
export default {"footerPart":"AuthFooter_footerPart__UFxgr"};